import { createAction } from '../../../../store.model';
import { ViewTaskItem } from '../model/view-task-item.model';
import { ActionType } from '../task-list-dialog.action';

export interface UpdateItem {
    task: ViewTaskItem;
}

export const updateItem = createAction<ActionType, UpdateItem>(
    ActionType.TC__TL__UPDATE_ITEM,
);
